export default {
  menu: {
    title: 'KDN',
  },
  messages: {
    title: 'Mín skilaboð',
  },
  navigation: {
    home: 'Heim',
    messages: 'Skilaboð',
    shifts: 'Allir leikir',
    upcomingShifts: 'Leikir framundan',
    pastShifts: 'Liðnir leikir',
    vacation: 'Sækja um frí',
    vacationSubtitle: 'Nauðsynlegt er að fylla út í fyrri reitinn',
    send: 'Staðfesta',
    stop: 'Hætta við',
    logout: {
      title: 'Skrá út',
      dialog: {
        title: 'Staðfesta',
        message: 'Ertu viss um að þú viljir skrá þig út?',
        error: {
          title: 'Villa',
          message: 'Ekki tókst að skrá notanda út',
        },
      },
    },
  },
  login: {
    title: 'Innskráning',
    email: 'Netfang',
    password: 'Lykilorð',
    submit: 'Innskrá',
    continue: 'Áfram',
    dialog: {
      error: {
        title: 'Villa',
        message: 'Innskráning mistókst. Hafðu samband við yfirmann.',
      },
    },
  },
  notifications: {
    defaultTitle: 'Skilaboð',
  },
  shifts: {
    title: 'Allir leikir',
    lastWeek: 'Leikir síðustu 7 daga',
    arrival: 'Leiktími',
    answerNeeded: 'Svar óskast',
    boat: 'Dómari',
    pier: 'Aðstoðar dómari',
    information: {
      ship: 'Skip',
    },
    newShift: {
      title: 'Athugið',
      accept: {
        title: 'Kemst',
        message: 'Staðfesting um að þú mætir í leikinn.',
      },
      reject: {
        title: 'Kemst ekki',
        message: 'Staðfesting um að þú mætir EKKI í leikinn.',
      },
    },
    dialog: {
      error: {
        title: 'Villa',
        message: 'Ekki tókst að sækja leiki.',
      },
      answerShift: {
        title: 'Villa',
        message: 'Ekki tókst að senda svar.',
      },
      messages: {
        title: 'Villa',
        message: 'Ekki tókst að uppfæra skilaboð.',
      },
    },
  },
  date: {
    format: {
      full: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
      dateTime: 'DD.MM.YYYY / HH:mm',
      dateDefault: 'DD.MM.YYYY',
      timeDate: 'HH:mm DD.MM.YYYY',
    },
  },
  allShifts: {
    title: 'Starfsmenn með þér í leik',
    single: 'Þú ert einn staðfestur í leik',
  },
  vacation: {
    title: 'Villa',
    message: 'Gat ekki sent beiðni, reyndu aftur eða hafðu samband við yfirmann',
  },
};
